




































































































































import { Component } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import VerCrearModal from './VerCrearModal.vue';
import VerEditarModal from './VerEditarModal.vue';
import HistoricoTipoEquipo from './HistoricoTipoEquipo.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    FormFieldsContainer,
    DatePicker,
    VerCrearModal,
    VerEditarModal,
    HistoricoTipoEquipo,
  },
})
export default class MatrizBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.MatrizProducto;

  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  filtro: any;
  showReporteGenerado: boolean = false;
  tipoeqid: any = '';
  pagina: number = 1;
  columnApi: any = null;
  gridApi: GridApi = null;
  dialog: boolean = false;
  dialog2: boolean = false;
  texto_reporte: string = '';
  ordesList: any[] = [];
  codigoEquipo: any = '';
  optionslist: any = [
    { text: 'ACTIVO', value: false },
    { text: 'INACTIVO', value: true },
  ];

  usuarioID: any = '';

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'tipoeqid',
        field: 'tipoeqid',
        cellStyle: { textAlign: 'left' },
        lockVisible: true,
        width: 130,
        hide: true,
      },
      {
        headerName: 'Código de Equipo',
        field: 'tipoeqcodigo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Nombre del Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 200,
      },
      {
        headerName: 'Nombre CRM',
        field: 'tipoeqname_crm',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 200,
      },
      {
        headerName: 'Nombre Existencia INET',
        field: 'tipoeqname_inet',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Seguimiento Seriado',
        field: 'tipoeqseriado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 180,
      },
      {
        headerName: 'Tipo Usado Asociado',
        field: 'nombre_asociado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 250,
      },
      {
        headerName: 'Cuenta existencias INET',
        field: 'tipoeqcuenta_inet',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 200,
      },
      {
        headerName: 'Clase',
        field: 'tipoeqperiferico',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        cellRenderer: params => {
          if (params.data.tipoeqperiferico == 'f') {
            return (
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'EQUIPO' +
              '</a>'
            );
          } else {
            return (
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'PERIFÉRICO' +
              '</a>'
            );
          }
        },
      },
      {
        headerName: 'Estado',
        field: 'tipoeqbaja',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        cellRenderer: params => {
          if (params.data.tipoeqbaja == 't') {
            return (
              '<i class="material-icons" title="Anulado" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: rgb(255, 58, 58)"></i>' +
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'INACTIVO' +
              '</a>'
            );
          } else {
            return (
              '<i class="material-icons" title="Vigente" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: #26FF26"></i>' +
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'ACTIVO' +
              '</a>'
            );
          }
        },
      },
    ],

    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
  };
  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');

    this.clearFilters();
  }

  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  async getReportes(usuarioID: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { usuarioID: usuarioID },
      'conecta_matriz_producto'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado del Equipo',
      id: 'tipoubicaid',
      value: 'tipoubicaname',
    },
  };

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  async clearFilters() {
    this.formFields.estado.value = undefined;

    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi.setRowData(this.ordesList);
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionEditar,
    this.accionExportar,
  ];
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onVerHistorico(this.handleHistoricoClick);
  }

  handleEditarClick(params: ICellRendererParams) {
    this.codigoEquipo = params.data;
    this.dialog2 = true;
  }

  selectedId: any;
  selectedNombre: any;
  codigo: any;
  ShowHistorico: boolean = false;
  handleHistoricoClick(params: ICellRendererParams) {
    this.ShowHistorico = true;
    this.selectedId = params.data.tipoeqid;
    this.selectedNombre = params.data.tipoeqname;
    this.codigo = params.data.tipoeqcodigo;
  }
  async handleBuscarClick() {
    let self = this;
    this.loadingService.showLoading();
    if (self.formFields.estado.value == undefined) {
      self.formFields.estado.value = 'Todos';
    }
    return fetchReportesSerie(
      {
        ESTADO: self.formFields.estado.value,
      },
      'conecta_matriz_producto/get_filtered_rs'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.gridApi.setRowData(data.data.data.LISTA);
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData((this.ordesList = []));
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  crear_equipo() {
    this.dialog = true;
  }
  async btn_exportar() {
    let body: any = this.filtros2body();
    body.extension = 'csv';
    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchReportesSerie(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'Reporte Tipo de Producto',
      },
      'conecta_matriz_producto/exportar'
    )
      .then((data: any) => {
        this.showReporteGenerado = true;
        this.loadingService.hideLoading('btn_exportar');

        this.texto_reporte = data.data.MENSAJE_RESPUESTA;

        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  filtros2body() {
    let body: any = {};

    if (this.formFields.estado.value == undefined) {
      body.ESTADO = 'Todos';
    } else {
      body.ESTADO = this.formFields.estado.value;
    }
    return body;
  }
  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }
  async handleCierreModalCrear() {
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi.setRowData(this.ordesList);
    this.dialog = false;
    this.dialog2 = false;
    this.ShowHistorico = false;
  }
}
